module.exports = __webpack_public_path__ + "img/img_hezuo_4@2x.d67df63f.png";